import {FC} from "react";

interface Props {
    title?:string;
    className?:string;
}

const Card: FC<Props> = (props) => {
    return (
        <div className={`bg-slate-100 border dark:bg-cardGray dark:border-slate-700 p-4 rounded-md shadow-md relative ${props.className}`}>
            {props.title && <h3 className='font-bold text-xl mb-3'>{props.title}</h3>}
            <div className="text-sm">
                {props.children}
            </div>
        </div>
    );
};

export default Card;